<script setup lang="ts">
import type { DashboardBusinessImpactMetric } from "../../features/dashboard/dashboard.types.ts";

defineProps<{
  metrics: DashboardBusinessImpactMetric[];
}>();
</script>

<template>
  <section class="dashboard-card rounded-[1.5rem] px-5 py-5">
    <div class="flex items-center justify-between gap-3">
      <h2 class="dashboard-text-primary text-lg font-semibold">
        Business Impact
      </h2>
      <span class="dashboard-text-muted text-xs"
        >High-signal commercial outcomes</span
      >
    </div>

    <div class="mt-4 grid gap-2">
      <div
        v-for="metric in metrics"
        :key="metric.label"
        class="dashboard-divider flex items-center justify-between gap-4 border-b py-3 text-sm last:border-b-0"
      >
        <span class="dashboard-text-secondary">{{ metric.label }}</span>
        <span
          class="text-2xl font-semibold"
          :class="
            metric.accent === 'positive'
              ? 'dashboard-text-positive'
              : 'dashboard-text-primary'
          "
        >
          {{ metric.value }}
        </span>
      </div>
    </div>

    <RouterLink
      :to="{ name: 'search-select-pos' }"
      class="dashboard-text-link mt-4 inline-flex items-center gap-2 text-sm font-semibold no-underline"
    >
      View impact details
      <span aria-hidden="true">›</span>
    </RouterLink>
  </section>
</template>
